import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Alert, Spinner, Row, Col, Form, Button } from 'react-bootstrap';
import { ApiManager } from '../../core/api-manager';
import { toast } from 'react-toastify';
import { LoginManager } from '../../core/login-manager';



export default function FormPrenotazione({ course }) {

    const navigate = useNavigate();
    const [factory, setFactory] = useState("");
    const [email, setEmail] = useState("");
    const [payment, setPayment] = useState("");
    const [numberUser, setNumberUser] = useState(0);
    const [iva, setIva] = useState("");
    const [notes, setNotes] = useState("");






    useEffect(() => {
        const u = LoginManager.getUserInfo()
        setEmail(u.email)
    }, []);

    async function sendEmail() {
        const body = {
            factory: factory,
            email: email,
            course: course,
            payment: payment,
            numberUser: numberUser,
            iva: iva,
            notes: notes
        }

        var res = await ApiManager.sendAuthenticatedRequest('/custom/send_email', body)
        if (res.success === 1) {
            toast.success("Richiesta inviata con successo!", { theme: 'colored' })
        } else {
            toast.error("Errore nell'invio della richiesta!", { theme: 'colored' })
        }

    }





    return (
        <Container fluid className='p-0 mt-4' style={{ backgroundColor: '#f7f7f7' }}>
            <Container fluid={'md'}>
                <Row className='d-flex py-5 align-items-center justify-content-center'>
                    <Col md={8}>
                        <Row>
                            <Col className='text-center mb-4 w-50'>
                                <h3>Prenota i tuoi posti</h3>
                                <p>L'invio della richiesta d'iscrizione non è da considerarsi come completata senza approvazione e pagamento correttamente eseguito</p>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Azienda</Form.Label>
                                    <Form.Control className='rounded-pill' type="text" placeholder="Azienda" onChange={(e) => { setFactory(e.target.value) }} />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>La tua mail</Form.Label>
                                    <Form.Control className='rounded-pill' type="text" value={email} onChange={(e) => { setEmail(e.target.value) }} />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Partita Iva</Form.Label>
                                    <Form.Control className='rounded-pill' type="text" placeholder="P.IVA" onChange={(e) => { setIva(e.target.value) }} />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Metodo di pagamento preferito</Form.Label>
                                    <Form.Control className='rounded-pill' type="text" placeholder="Bonifico bancario" onChange={(e) => { setPayment(e.target.value) }} />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Numero di posti</Form.Label>
                                    <Form.Control className='rounded-pill' type="number" value={numberUser} onChange={(e) => { setNumberUser(e.target.value) }} />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Email dei partecipanti</Form.Label>
                                    <Form.Control className='rounded-pill' type="text" placeholder="" />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Altre note</Form.Label>
                                    <Form.Control as="textarea" rows={3} onChange={(e) => { setNotes(e.target.value) }} />
                                </Form.Group>
                            </Col>
                        </Row>
                        <div className='d-flex flex-row'>
                            <Form.Check
                                type='checkbox'
                            />
                            <p className='mx-1'>Ho letto ed accettato la</p><a href='https://www.fedespedi.it/privacy-policy/' target='_blank'> Privacy Policy</a>
                        </div>
                        <Row>
                            <Col>



                            </Col>
                        </Row>
                        <Row className='mt-4'>
                            <Col className='text-center'>
                                <Button className='px-3 rounded-pill' onClick={() => { sendEmail() }}>Invia Richiesta</Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </Container>
    );

};